import React, { useContext } from "react";
import { BrowserRouter as RouterProvider } from "react-router-dom";
import { createTheme, ThemeProvider, CssBaseline } from "@mui/material";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  createHttpLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { AuthContext } from "./Context/AuthContext";
import { QueryClient, QueryClientProvider } from "react-query";
// App Resources
import "./App.css";
import Router from "./routes";
import AlertMessage from "./Components/AlertMessage/AlertMessage";

const getToken = () => {
  return window.localStorage.getItem("token") || "";
};

const getMandateId = () => {
  return window.localStorage.getItem("mandate_id") || "";
};

function App() {
  const { state } = useContext(AuthContext);
  const { user } = state;
  // ==================== Token Management ===================
  const token = getToken();
  const mandateId = getMandateId();

  // ==================== MUI Theme Setup ====================
  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          background: {
            default: "#EBEDEF",
          },
        },
        typography: {
          fontFamily: [
            "Century Gothic",
            "Siemreap",
            "PublicSans",
            "sans-serif",
          ].join(","),
        },
      }),
    []
  );

  // ==================== Apollo Client Setup ====================
  const httpLink = createHttpLink({
    // uri: "http://192.168.5.36:3420/graphql",
    // uri: "http://localhost:3420/graphql",
    uri: process.env.REACT_APP_END_POINT,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      "x-mandate-id": mandateId,
      authorization: token,
    },
  }));

  const apolloClient = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
  });

  // ==================== React Query Setup ====================
  const queryClient = new QueryClient();

  // ==================== Render App ===========================
  return (
    <ApolloProvider client={apolloClient}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RouterProvider>
            <Router />
          </RouterProvider>
        </ThemeProvider>
        <AlertMessage />
      </QueryClientProvider>
    </ApolloProvider>
  );
}


export default App;
